import { render } from "./RouteHolidays.vue?vue&type=template&id=a0e6de6a&scoped=true&ts=true"
import script from "./RouteHolidays.vue?vue&type=script&lang=ts"
export * from "./RouteHolidays.vue?vue&type=script&lang=ts"

import "./RouteHolidays.vue?vue&type=style&index=0&id=a0e6de6a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0e6de6a"]])

export default __exports__